// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PERFILES_SET_ROLE_ID_CLONED,
} from './constants';

export function setRoleIdCloned(id) {
  return {
    type: PERFILES_SET_ROLE_ID_CLONED,
    data: id
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERFILES_SET_ROLE_ID_CLONED:
      return {
        ...state,
        roleIdCloned: action.data
      };

    default:
      return state;
  }
}
